import { render, staticRenderFns } from "./addBus.vue?vue&type=template&id=b1544fcc"
import script from "./addBus.vue?vue&type=script&lang=js"
export * from "./addBus.vue?vue&type=script&lang=js"
import style0 from "./addBus.vue?vue&type=style&index=0&id=b1544fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports